import { render, staticRenderFns } from "./ResultVBT.vue?vue&type=template&id=702c394d&scoped=true"
import script from "./ResultVBT.vue?vue&type=script&lang=js"
export * from "./ResultVBT.vue?vue&type=script&lang=js"
import style0 from "./ResultVBT.vue?vue&type=style&index=0&id=702c394d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702c394d",
  null
  
)

export default component.exports